import { render, staticRenderFns } from "./TkCarrierLogo.vue?vue&type=template&id=1d11eeb4&"
import script from "./TkCarrierLogo.vue?vue&type=script&lang=js&"
export * from "./TkCarrierLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports